import axiosClient from "./axiosClient";
import { toast } from "react-toastify";


export const createFeedback = async (data) => {
  try {
    const response = await axiosClient.post(`/user-service/feedback`, data);

    if (response?.status === "SUCCESS") {
      toast.success(response.message || "Feedback sent successfully");
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while creating the survey");
  }
};

export const fetchFeedbackByDoctorId = async (data) => {
  try {
    const response = await axiosClient.get(`/user-service/feedback/${data}`);
    if (response?.status === "SUCCESS") {

      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while creating the survey");
  }
};